import {
  isNewBigPurchaseFlowExperimentActive,
  isNewBuildCreditFlowExperimentActive,
  isNewBalanceTransferFlowExperimentActive,
} from './../../lib/experiments';
import {
  Flow,
  flow,
  variantBigPurchaseFlowFragment,
  travelFlowFragment,
  bigPurchaseFlowFragment,
  cashbackFlowFragment,
  debtFlowFragment,
  debtFlowVariantFragment,
  buildCreditFlowFragment,
  buildCreditVariantFlowFragment,
  FlowScreen,
} from 'src/lib/flows/flow-definition';
import { AppThunk } from '../store';
import {
  getExperiments,
  getInitialScreen,
  getInputQueryParams,
  getInputs,
  getIsMobileApp,
  getIsSignedIn,
  getAuth0State,
  getUserEmail,
  getVisitedScreens,
  getAuth0Variant,
} from 'src/redux/selectors';
import { PrimaryGoal, CreditScore } from 'src/types/inputs';
import { Screen } from 'src/lib/flows/screens';
import { isEmpty } from 'lodash';

export const getActiveFlow = (): AppThunk<Flow> => (dispatch, getState) => {
  const state = getState();
  const experiments = getExperiments(state);

  const buildCreditFragment = isNewBuildCreditFlowExperimentActive(experiments)
    ? buildCreditVariantFlowFragment
    : buildCreditFlowFragment;

  const debtFragment = isNewBalanceTransferFlowExperimentActive(experiments)
    ? debtFlowVariantFragment
    : debtFlowFragment;

  const bigPurchaseFragment = isNewBigPurchaseFlowExperimentActive(experiments)
    ? variantBigPurchaseFlowFragment
    : bigPurchaseFlowFragment;

  const result = {
    ...flow,
    ...(state.inputs?.primaryGoal === PrimaryGoal.Travel && travelFlowFragment),
    ...(state.inputs?.primaryGoal === PrimaryGoal.BigPurchase &&
      bigPurchaseFragment),
    ...(state.inputs?.primaryGoal === PrimaryGoal.CashBack &&
      cashbackFlowFragment),
    ...(state.inputs?.primaryGoal === PrimaryGoal.Debt && debtFragment),
    ...(state.inputs?.primaryGoal === PrimaryGoal.BuildCredit &&
      buildCreditFragment),
    ...(state.inputs?.creditScore === CreditScore.LimitedCreditHistory &&
      isNewBuildCreditFlowExperimentActive(experiments) &&
      buildCreditVariantFlowFragment),
  };

  return result;
};

export const isStepAllowed =
  (step: Screen): AppThunk<boolean> =>
  (dispatch, getState): boolean => {
    const state = getState();
    const visitedScreens = getVisitedScreens(state);
    const currentFlow = dispatch(getActiveFlow());
    const initialScreen = getInitialScreen(state);
    const inputs = getInputs(state);
    const queryParams = getInputQueryParams(state);
    const auth0State = getAuth0State(state);

    if (step === initialScreen || visitedScreens.length === 0) return true;

    let allowStep = !!(
      auth0State &&
      !isEmpty(inputs) &&
      step === Screen.Loading
    );
    for (const visitedScreen of visitedScreens) {
      const currentScreen: FlowScreen = currentFlow?.[visitedScreen];
      const currentScreenInput = currentScreen?.inputs?.[0];
      let nextQuestion;
      if (typeof currentScreen?.toScreen === 'function') {
        nextQuestion = currentScreen.toScreen({
          inputs,
          experiments: getExperiments(state),
          isSignedIn: getIsSignedIn(state),
          userEmail: getUserEmail(state),
          isMobileApp: getIsMobileApp(state),
          auth0Variant: getAuth0Variant(state),
          queryParams,
        });
      } else {
        nextQuestion = currentScreen?.toScreen[0];
      }
      if (
        nextQuestion === step &&
        (typeof currentScreenInput === 'undefined' ||
          typeof inputs[currentScreenInput] !== 'undefined')
      ) {
        allowStep = true;
        break;
      }
    }
    return allowStep;
  };
